console.log("Nordaus Product Grid Loaded");


/* ==========================================================
   NORDAUS PRODUCT GRID
   - Product image slider
   - Mobile swipe
   - Infinite scroll
   - Exchange mode
   - Real Shopify product selection
========================================================== */


/* ==========================================================
   PRODUCT CARD INITIALIZER
========================================================== */

function initProductCard(card) {

  const slides =
    card.querySelectorAll(".nd-pg-slide");

  const dots =
    card.querySelectorAll(".nd-pg-dots span");

  const prev =
    card.querySelector(".nd-pg-arrow-left");

  const next =
    card.querySelector(".nd-pg-arrow-right");

  if (slides.length <= 1) return;


  let current = 0;

  let startX = 0;
  let endX = 0;


  /* --------------------------------------------------------
     Initial State
  -------------------------------------------------------- */

  slides.forEach((slide, index) => {

    slide.classList.toggle(
      "active",
      index === 0
    );

  });


  dots.forEach((dot, index) => {

    dot.classList.toggle(
      "active",
      index === 0
    );

  });


  /* --------------------------------------------------------
     Show Slide
  -------------------------------------------------------- */

  function showSlide(index) {

    if (!slides[current]) return;

    slides[current].classList.remove(
      "active"
    );


    if (dots[current]) {

      dots[current].classList.remove(
        "active"
      );

    }


    current = index;


    if (slides[current]) {

      slides[current].classList.add(
        "active"
      );

    }


    if (dots[current]) {

      dots[current].classList.add(
        "active"
      );

    }

  }


  /* --------------------------------------------------------
     Next
  -------------------------------------------------------- */

  if (next) {

    next.addEventListener(
      "click",
      (event) => {

        event.preventDefault();
        event.stopPropagation();


        let index =
          current + 1;


        if (
          index >=
          slides.length
        ) {

          index = 0;

        }


        showSlide(index);

      }
    );

  }


  /* --------------------------------------------------------
     Previous
  -------------------------------------------------------- */

  if (prev) {

    prev.addEventListener(
      "click",
      (event) => {

        event.preventDefault();
        event.stopPropagation();


        let index =
          current - 1;


        if (index < 0) {

          index =
            slides.length - 1;

        }


        showSlide(index);

      }
    );

  }


  /* --------------------------------------------------------
     Dots
  -------------------------------------------------------- */

  dots.forEach(
    (dot, index) => {

      dot.addEventListener(
        "click",
        (event) => {

          event.preventDefault();
          event.stopPropagation();


          showSlide(index);

        }
      );

    }
  );


  /* --------------------------------------------------------
     Mobile Swipe
  -------------------------------------------------------- */

  const imageArea =
    card.querySelector(
      ".nd-pg-slider"
    );


  if (imageArea) {

    imageArea.addEventListener(
      "touchstart",
      (event) => {

        startX =
          event.touches[0].clientX;

      },
      {
        passive: true
      }
    );


    imageArea.addEventListener(
      "touchend",
      (event) => {

        endX =
          event.changedTouches[0].clientX;


        const distance =
          startX - endX;


        const SWIPE_THRESHOLD =
          50;


        if (
          Math.abs(distance) <
          SWIPE_THRESHOLD
        ) {

          return;

        }


        /* Swipe Left */

        if (distance > 0) {

          let index =
            current + 1;


          if (
            index >=
            slides.length
          ) {

            index = 0;

          }


          showSlide(index);

        }


        /* Swipe Right */

        else {

          let index =
            current - 1;


          if (index < 0) {

            index =
              slides.length - 1;

          }


          showSlide(index);

        }

      },
      {
        passive: true
      }
    );

  }

}


/* ==========================================================
   INITIAL PAGE LOAD
========================================================== */

document.addEventListener(
  "DOMContentLoaded",
  () => {

    document
      .querySelectorAll(
        ".nd-pg-card"
      )
      .forEach(
        initProductCard
      );

  }
);


/* ==========================================================
   NORDAUS INFINITE SCROLL
========================================================== */

document.addEventListener(
  "DOMContentLoaded",
  () => {

    const nextPage =
      document.getElementById(
        "nd-pg-next-page"
      );


    const grid =
      document.querySelector(
        ".nd-pg-grid"
      );


    const loader =
      document.getElementById(
        "nd-pg-loader"
      );


    if (
      !nextPage ||
      !grid
    ) {

      return;

    }


    let loading = false;


    const observer =
      new IntersectionObserver(
        async (entries) => {

          if (
            !entries[0].isIntersecting ||
            loading
          ) {

            return;

          }


          const url =
            nextPage.dataset.url;


          if (!url) {

            return;

          }


          loading = true;


          try {

            if (loader) {

              loader.classList.add(
                "active"
              );

            }


            const response =
              await fetch(url);


            const html =
              await response.text();


            const parser =
              new DOMParser();


            const doc =
              parser.parseFromString(
                html,
                "text/html"
              );


            const newCards =
              doc.querySelectorAll(
                ".nd-pg-card"
              );


            newCards.forEach(
              (card) => {

                grid.appendChild(
                  card
                );


                initProductCard(
                  card
                );

              }
            );


            const newNext =
              doc.querySelector(
                "#nd-pg-next-page"
              );


            if (newNext) {

              nextPage.dataset.url =
                newNext.dataset.url;

            } else {

              observer.disconnect();

              nextPage.remove();

            }


            /*
              Exchange buttons are added
              through the MutationObserver
              below.
            */

          } catch (error) {

            console.error(
              "Nordaus Infinite Scroll:",
              error
            );

          }


          if (loader) {

            loader.classList.remove(
              "active"
            );

          }


          loading = false;

        },
        {
          rootMargin: "300px"
        }
      );


    observer.observe(
      nextPage
    );

  }
);


/* ==========================================================
   NORDAUS EXCHANGE MODE
==========================================================

   Exchange mode is active when the collection URL contains:

   ?exchange=1

   OR

   ?exchange_return=1

   Normal collection browsing remains unchanged.
========================================================== */

document.addEventListener(
  "DOMContentLoaded",
  () => {

    const params =
      new URLSearchParams(
        window.location.search
      );


    const exchangeMode =
      params.get("exchange") === "1" ||
      params.get("exchange_return") === "1";


    if (!exchangeMode) {

      return;

    }


    document.body.classList.add(
      "nd-exchange-mode"
    );


    const grid =
      document.querySelector(
        ".nd-pg-grid"
      );


    if (!grid) {

      return;

    }


    /* ======================================================
       GET PRODUCT HANDLE FROM CARD
    ====================================================== */

    function getProductHandle(card) {

      /*
        Your current Liquid does not provide
        data-product-handle.

        So we safely obtain the handle
        from the product URL instead.
      */

      const productLink =
        card.querySelector(
          ".nd-pg-info a"
        ) ||
        card.querySelector(
          ".nd-pg-image a"
        );


      if (
        !productLink ||
        !productLink.href
      ) {

        return "";

      }


      try {

        const url =
          new URL(
            productLink.href,
            window.location.origin
          );


        const parts =
          url.pathname.split(
            "/"
          );


        const productsIndex =
          parts.indexOf(
            "products"
          );


        if (
          productsIndex === -1 ||
          !parts[productsIndex + 1]
        ) {

          return "";

        }


        return parts[
          productsIndex + 1
        ];

      } catch (error) {

        console.error(
          "Nordaus Product Handle:",
          error
        );


        return "";

      }

    }


    /* ======================================================
       FETCH REAL SHOPIFY PRODUCT DATA
    ====================================================== */

    async function getShopifyProduct(
      handle
    ) {

      if (!handle) {

        return null;

      }


      try {

        const response =
          await fetch(
            `/products/${handle}.js`
          );


        if (!response.ok) {

          throw new Error(
            `Product request failed: ${response.status}`
          );

        }


        const product =
          await response.json();


        return product;

      } catch (error) {

        console.error(
          "Nordaus Exchange Product:",
          error
        );


        return null;

      }

    }


    /* ======================================================
       ADD SELECT FOR EXCHANGE BUTTON
       TO EVERY PRODUCT CARD
    ====================================================== */

    function addExchangeButtons() {

      const cards =
        grid.querySelectorAll(
          ".nd-pg-card"
        );


      cards.forEach(
        (card) => {

          /*
            Avoid creating the button twice.
          */

          if (
            card.querySelector(
              ".nd-pg-exchange-button"
            )
          ) {

            return;

          }


          const productId =
            card.dataset.productId ||
            "";


          const productHandle =
            getProductHandle(
              card
            );


          const button =
            document.createElement(
              "button"
            );


          button.type =
            "button";


          button.className =
            "nd-pg-exchange-button";


          button.innerHTML = `

            <span>
              Select for Exchange
            </span>

            <span aria-hidden="true">
              →
            </span>

          `;


          button.dataset.productId =
            productId;


          button.dataset.productHandle =
            productHandle;


          /*
            IMPORTANT:
            Do not navigate directly
            before Shopify product data
            has been saved.
          */

          button.addEventListener(
            "click",
            async (event) => {

              event.preventDefault();

              event.stopPropagation();


              if (!productHandle) {

                alert(
                  "We couldn't identify this product. Please try again."
                );

                return;

              }


              /*
                Prevent double clicks.
              */

              button.disabled =
                true;


              button.classList.add(
                "is-loading"
              );


              const originalText =
                button.innerHTML;


              button.innerHTML = `

                <span>
                  Selecting...
                </span>

              `;


              try {

                /*
                  Fetch the REAL Shopify
                  product.
                */

                const product =
                  await getShopifyProduct(
                    productHandle
                  );


                if (!product) {

                  throw new Error(
                    "Product data unavailable."
                  );

                }


                /*
                  Shopify's Ajax Product API
                  returns price in the store's
                  currency in the "price" field
                  as a number in the smallest
                  currency unit.

                  For INR:
                  ₹1,200 = 120000 paise.
                */

                const price =
                  Number(
                    product.price
                  ) / 100;


                /*
                  Use the actual Shopify
                  product image.
                */

                let image = "";


                if (
                  product.images &&
                  product.images.length
                ) {

                  image =
                    product.images[0];

                }


                /*
                  Create the complete
                  replacement object.
                */

                const replacement = {

                  id:
                    product.id ||
                    productId,

                  handle:
                    product.handle ||
                    productHandle,

                  title:
                    product.title ||
                    "",

                  price:
                    price,

                  image:
                    image || "",

                  vendor:
                    product.vendor ||
                    "NORDAUS"

                };


                /*
                  IMPORTANT:
                  This is the missing hand-off.

                  The Returns & Exchange page
                  reads this exact key.
                */

                sessionStorage.setItem(
                  "ndExchangeReplacement",
                  JSON.stringify(
                    replacement
                  )
                );


                /*
                  Confirm that the browser
                  actually stored it before
                  leaving the collection.
                */

                const savedReplacement =
                  sessionStorage.getItem(
                    "ndExchangeReplacement"
                  );


                if (!savedReplacement) {

                  throw new Error(
                    "Exchange selection could not be saved."
                  );

                }


                console.log(
                  "Nordaus Exchange Replacement Saved:",
                  replacement
                );


                /*
                  Return to Returns & Exchange.

                  exchange_return=1 tells the
                  Returns page to restore the
                  exchange state.
                */

                window.location.href =
                  "/pages/return-exchange?exchange_return=1";


              } catch (error) {

                console.error(
                  "Nordaus Exchange Selection:",
                  error
                );


                alert(
                  "We couldn't select this product right now. Please try again."
                );


                button.disabled =
                  false;


                button.classList.remove(
                  "is-loading"
                );


                button.innerHTML =
                  originalText;

              }

            }
          );


          const info =
            card.querySelector(
              ".nd-pg-info"
            );


          if (info) {

            info.appendChild(
              button
            );

          }

        }
      );

    }


    /* ======================================================
       INITIAL PRODUCTS
    ====================================================== */

    addExchangeButtons();


    /* ======================================================
       NEW PRODUCTS FROM INFINITE SCROLL
    ====================================================== */

    const mutationObserver =
      new MutationObserver(
        () => {

          addExchangeButtons();

        }
      );


    mutationObserver.observe(
      grid,
      {
        childList: true
      }
    );

  }
);